import { render } from "./Main.vue?vue&type=template&id=1c8961f2&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=1c8961f2&scoped=true&lang=css"

import exportComponent from "/Users/siorikitajima/Dropbox (Personal)/Code/GCV/ga-emc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c8961f2"]])

export default __exports__